'use es6';

import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import * as Actions from 'FormsUI/actions/SubmissionStatus';
export function submissionStatus(state = {}, action) {
  const {
    formGuid,
    dateRange
  } = action;
  switch (action.type) {
    case Actions.REQUEST_FORM_SUBMISSIONS_COUNT:
      return Object.assign({}, state, {
        [JSON.stringify({
          formGuid,
          dateRange
        })]: {
          data: {},
          requestState: RequestState.REQUESTED
        }
      });
    case Actions.SUCCEED_GETTING_FORM_SUBMISSIONS_COUNT:
      return Object.assign({}, state, {
        [JSON.stringify({
          formGuid,
          dateRange
        })]: {
          data: action.response,
          requestState: RequestState.SUCCEEDED
        }
      });
    case Actions.FAIL_GETTING_FORM_SUBMISSIONS_COUNT:
      return Object.assign({}, state, {
        [JSON.stringify({
          formGuid,
          dateRange
        })]: {
          data: {},
          requestState: RequestState.FAILED
        }
      });
    default:
      return state;
  }
}